<div
  *ngIf="warningMessage"
  class="d-flex align-items-center justify-content-center m-2 border rounded p-1 yellow-bg"
>
  <span class="d-flex align-items-center small gap-2 wrap"
    ><mat-icon>warning</mat-icon> {{ warningMessage }}</span
  >
</div>
